import { partnerAdminFetch } from '~/api/partnerAdminFetch';
import { ApiError } from '../../../action/apiError';
import { ResponseClientAdminUserType } from '../../../types/resources/ClientAdminUserType';

const endpoint = '/partner_admins/client_admin_users';

type ResponseType = {
  client_admin_user: ResponseClientAdminUserType;
};

export async function getClientAdminUser(user_id: string): Promise<ResponseType> {
  const response = await partnerAdminFetch(`${endpoint}/${user_id}`, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  return response.json();
}

export async function updateClientAdminUser(data, user_id: string): Promise<ResponseType> {
  const response = await partnerAdminFetch(`${endpoint}/${user_id}`, {
    method: 'PUT',
    data: data,
  });

  if (!response.ok) {
    const errorDetails = await response.json();
    throw new ApiError(
      `HTTP ${response.status} ${response.statusText}`,
      errorDetails.errors || [errorDetails.message]
    );
  }

  return response.json();
}

export async function deleteClientAdminUser(user_id: number): Promise<void> {
  const response = await partnerAdminFetch(`${endpoint}/${user_id}`, {
    method: 'DELETE',
  });

  if (!response.ok) {
    const errorDetails = await response.json();
    throw new ApiError(
      `HTTP ${response.status} ${response.statusText}`,
      errorDetails.errors || [errorDetails.message]
    );
  }
}
